// ═══════════════════════════════════════════════════════════════════════
// data/contact.js — contact_submissions table access (extracted from App.js)
// ═══════════════════════════════════════════════════════════════════════
// Thin wrapper for the Landing-page contact form insert. Behaviour-identical
// to the previous inline query; returns the raw Supabase `{ error }` so the
// caller keeps its own error handling. RLS + a DB-side rate limit guard it.
import { supabase } from "../lib/supabaseClient";
import { API_BASE } from "../lib/api";

export async function insertContactSubmission(payload) {
  // Save the submission (RLS + a DB-side rate limit guard this insert).
  const result = await supabase.from("contact_submissions").insert(payload);
  // Best-effort: also notify hello@netrev.ai via the backend. The submission
  // is already saved above, so a mail hiccup must NOT surface as a form error —
  // swallow any failure and return the original insert result unchanged.
  if (!result.error) {
    try {
      await fetch(`${API_BASE}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
    } catch (_) { /* notification only — ignore */ }
  }
  return result;
}
